/* eslint-disable max-len */
import {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppContext } from '../../contexts/auth';
import { aiBaseUrl, useGeminiStream } from '../../enviromentVariables';
import { useQuery } from '../../hooks/useQuery';
import homeService from '../../services/homeService';
import resultService from '../../services/resultService';
import formatCurrency from '../../utils/formatCurrency';
import renderArrayWithComa from '../../utils/renderArrayWithComa';
// import sendLinkWhatsapp from '../../utils/sendLinkWhatsapp';
// import sendDocumentWhatsapp from '../../utils/sendDocumentWhatsapp';

export default function useResult() {
  const [isLoading, setIsLoading] = useState(true);
  const [goingRoute, setGoingRoute] = useState([]);
  const [returningRoute, setReturningRoute] = useState([]);
  const [tickets, setTickets] = useState([]);
  // const [employeeCellphone, setEmployeeCellphone] = useState('');
  // const [employeeName, setEmployeeName] = useState('');
  // const [companyName, setCompanyName] = useState('');
  const [view, setView] = useState('going');
  const [hasError, setHasError] = useState(false);
  const [exceededPrice, setExceededPrice] = useState(false);
  const [totalPrice, setTotalPrice] = useState('');
  const [resultStatus, setResultStatus] = useState('waiting');
  const [allowPdfDownload, setAllowPdfDownload] = useState(true);
  const [isTicketsTabVisible, setIsTicketsTabVisible] = useState(true);

  const [isSomeActionLoading, setIsSomeActionLoading] = useState(false);
  const [adjustmentReason, setAdjustmentReason] = useState('');
  const [adjustmentModalShow, setAdjustmentModalShow] = useState(false);
  const [refuseModalShow, setRefuseModalShow] = useState(false);
  const [acceptModalShow, setAcceptModalShow] = useState(false);

  const [remainingAdjustmentChars, setRemainingAdjustmentChars] = useState(300);

  const [isRefuseButtonDisabled, setIsRefuseButtonDisabled] = useState(true);
  const [isAcceptButtonDisabled, setIsAcceptButtonDisabled] = useState(true);

  const [canShowMap, setCanShowMap] = useState(false);

  const [isBkConsultAndNotOptimized, setIsBkConsultAndNotOptimized] = useState(false);
  const [companyToRedirectMinorApprentice, setCompanyToRedirectMinorApprentice] = useState('');
  const [isMinorApprentice, setIsMinorApprentice] = useState(false);

  const [lastReclamationAndAnswer, setLastReclamationAndAnswer] = useState('');

  const [aiChatHistory, setAiChatHistory] = useState([]);
  const [aiModalShow, setAiModalShow] = useState(false);
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [aiStreamingText, setAiStreamingText] = useState('');
  const aiStreamingTextRef = useRef('');
  const streamingDoneResolverRef = useRef(null);
  const pendingAiResultRef = useRef(null);
  const [canUseAiAssistant, setCanUseAiAssistant] = useState(false);
  const [aiRejectionReason, setAiRejectionReason] = useState('');
  const [companyId, setCompanyId] = useState(null);
  const [rejectionReasonModalShow, setRejectionReasonModalShow] = useState(false);
  const [forceResultShow, setForceResultShow] = useState(false);

  const { token } = useAppContext();
  const query = useQuery();
  const consultCode = query.get('codConsulta');
  const employeeCode = query.get('codFuncionario');
  const isVtRegistration = query.has('isVtRegistration');
  const hasAlreadyTriedAutoRouting = query.has('hasAlreadyTriedAutoRouting');
  const navigate = useNavigate();
  const [logo, setLogo] = useState(query.get('logo'));

  const checkAiRecalculationStatus = useCallback(async (routingId, companyIdParam) => {
    const status = { forceResultShow: false, recalculationTriggered: false };
    try {
      const response = await fetch(`${aiBaseUrl}/gemini/recalculation-status/${routingId}`);
      const data = await response.json();

      const shouldForceShow = data.forceResultShow === true;
      setForceResultShow(shouldForceShow);
      status.forceResultShow = shouldForceShow;

      if (!data.hasHistory) {
        setCanUseAiAssistant(true);
        setAiRejectionReason('');
      } else if (data.status === 'objectionRejected') {
        setCanUseAiAssistant(false);
        setAiRejectionReason(data.rejectionReason || '');
        if (data.rejectionReason && !shouldForceShow) {
          setRejectionReasonModalShow(true);
        }

        if (data.recalculationTriggered && !shouldForceShow) {
          status.recalculationTriggered = true;
          navigate(`/?codEmpresa=${companyIdParam}&codConsulta=${consultCode}&codFuncionario=${employeeCode}`);
          return status;
        }
      } else {
        setCanUseAiAssistant(false);
        setAiRejectionReason('');
      }
    } catch (error) {
      setCanUseAiAssistant(false);
      setAiRejectionReason('');
    }

    return status;
  }, [consultCode, employeeCode, navigate]);

  const checkIfCanShowMap = useCallback(async () => {
    const checkMap = await fetch(`https://capta-api-a985a69f6b33.herokuapp.com/utils/map/${consultCode}_1_1_1`);
    // const checkMap = await fetch(`http://localhost:3001/routing-maps/${consultCode}_1_1_1`);

    const canShow = await checkMap.json();

    if (canShow.success) {
      setCanShowMap(true);
      return;
    }

    setCanShowMap(false);
  }, [consultCode]);

  const getLogo = useCallback(async (companyCode) => {
    const companyLogo = await homeService.checkIsCompanyHabilitated({
      codEmpresa: companyCode,
      token,
    });
    return companyLogo.linkLogo || '';
  }, [token]);

  const getResult = useCallback(async () => {
    try {
      const result = await resultService.getResult({
        codConsulta: consultCode,
        codFuncionario: employeeCode,
        token,
      });
      if (!result.codigo) {
        toast.error(`Não foi possível carregar seu resultado. Por favor, tente novamente (${result.msg}).`);
        setHasError(true);
        return;
      }
      if (result.dadosFuncionario.codEmpresa === 24175 && result.dadosConsulta.statusRot === 69) {
        setIsBkConsultAndNotOptimized(true);
        return;
      }
      if (result.dadosConsulta.statusRot === 69) {
        setIsTicketsTabVisible(false);
      }
      const companyCode = result.dadosFuncionario.codEmpresa;
      setCompanyId(companyCode);
      const companyLogo = await getLogo(companyCode);
      setLogo(companyLogo);
      const aiStatus = await checkAiRecalculationStatus(consultCode, companyCode);
      const aiForceResultShow = aiStatus.forceResultShow;
      if (aiStatus.recalculationTriggered) {
        return;
      }
      const routingTotalPrice = result.dadosConsulta.valorVtTotal;

      if (isVtRegistration && !aiForceResultShow) {
        const valueByCompany = result.dadosFuncionario.valorVTInfo;
        const valueByEmployee = result.dadosConsulta.valorTotalInformadoMyLinkFull;
        const automaticRoutingValue = result.dadosConsulta.valorTotalRotAutomatica;
        const currentValueTaken = routingTotalPrice == automaticRoutingValue ? 'aut' : 'mylinkfull';

        let actionToTake = 'none';
        if (currentValueTaken === 'mylinkfull' && !automaticRoutingValue && valueByEmployee > valueByCompany && !hasAlreadyTriedAutoRouting) {
          actionToTake = 'autRouting';
        } else if (currentValueTaken === 'aut' && valueByEmployee && automaticRoutingValue && automaticRoutingValue >= valueByEmployee && hasAlreadyTriedAutoRouting) {
          actionToTake = 'backToMyLinkFull';
        }

        const actionsMap = {
          // eslint-disable-next-line no-console
          none: () => { console.log('none'); },
          autRouting: async () => {
            // console.log('autRouting');
            await homeService.calculateRoute({
              codEmpresa: companyCode,
              codLocTrab: result.dadosLocTrab.codEndCliente,
              semIntregraRJ: Boolean(result.dadosConsulta.semIntregraRJ),
              forcarReprocessamento: true,
              token,
              reqBody: JSON.stringify({
                cpf: result.dadosFuncionario.cpf,
                nome: result.dadosFuncionario.nome,
                email: result.dadosFuncionario.email,
                cepF: result.dadosFuncionario.cepF,
                logradouroF: result.dadosFuncionario.logradouroF,
                numF: Number(result.dadosFuncionario.numF),
                complementoF: result.dadosFuncionario.complF,
                bairroF: result.dadosFuncionario.bairroF,
                cidadeF: result.dadosFuncionario.cidadeF,
                ufF: result.dadosFuncionario.ufF,
                celularFunc: result.dadosFuncionario.celularFunc,
                horaEntra: result.dadosFuncionario.horaEntra,
                horaSai: result.dadosFuncionario.horaSai,
                usaFretado: result.dadosConsulta.usaFretado,
                rg: result.dadosFuncionario.rg || '',
                nomeMae: result.dadosFuncionario.nomeMae || '',
                dataNascimento: result.dadosFuncionario.dataNascimento ? new Date(result.dadosFuncionario.dataNascimento) : new Date(),
              }),
            });

            navigate(`/?codEmpresa=${companyCode}&codConsulta=${consultCode}&codFuncionario=${employeeCode}&isVtRegistration&hasAlreadyTriedAutoRouting`);
          },
          backToMyLinkFull: async () => {
            // console.log('backToMyLinkFull');
            await homeService.confirmManualRouting({
              token,
              reqBody: JSON.stringify({
                appCode: 2,
                codConsulta: consultCode,
                codFuncionario: employeeCode,
                codEmpresa: companyCode,
                bilhetes: result.bilhetesInformadosMyLinkFull,
              }),
            });

            navigate(`/?codEmpresa=${companyCode}&codConsulta=${consultCode}&codFuncionario=${employeeCode}&isVtRegistration&hasAlreadyTriedAutoRouting`);
          },
        };

        await actionsMap[actionToTake]();
      }
      const minorAprrenticeCompanies = [45165, 45210, 47262];
      const isCompanyMinorApprentice = minorAprrenticeCompanies.includes(result.dadosFuncionario.codEmpresa);
      const redirectCompanyMap = {
        45165: '45166',
        45234: '45210',
        47262: '47270',
      };
      setIsMinorApprentice(isCompanyMinorApprentice);
      setCompanyToRedirectMinorApprentice(isCompanyMinorApprentice ? redirectCompanyMap[result.dadosFuncionario.codEmpresa] : '');

      setTotalPrice(formatCurrency(routingTotalPrice));
      setGoingRoute(result.trajetoIda);
      setReturningRoute(result.trajetoVolta);
      setTickets(result.valeTransp);
      setLastReclamationAndAnswer(result.ultimaReclamacao);
      // setEmployeeCellphone(result.dadosFuncionario.celularFunc);
      // setEmployeeName(result.dadosFuncionario.nome);
      // setCompanyName(result.nomeEmp);
      setAllowPdfDownload(result.ExibeCarta);
      const maxPriceAllowed = result.valorTeto;
      const hasExceededPrice = (
        !aiForceResultShow
        && routingTotalPrice > maxPriceAllowed
        && maxPriceAllowed !== 0);
      setExceededPrice(hasExceededPrice);
      if (hasExceededPrice) {
        toast.warn('Seu resultado está acima do valor máximo permitido pela sua empresa. Para mais detalhes entre em contato com o RH.', {
          icon: '💵',
          autoClose: false,
        });
      }

      // const isTestCompany = companyCode == 44106;
      // if (isTestCompany) {
      // }
    } catch (error) {
      toast.error(`Não foi possível carregar seu resultado. Por favor, tente novamente (${error}).`);
      setHasError(true);
    }
  }, [consultCode, employeeCode, getLogo, hasAlreadyTriedAutoRouting, isVtRegistration, navigate, token, checkAiRecalculationStatus]);

  const checkResultStatus = useCallback(async () => {
    try {
      const bodyResultStatus = await resultService.checkResultStatus({
        codConsulta: consultCode,
        token,
      });
      if (!bodyResultStatus.codigo) {
        toast.error(`Não foi possível carregar seu resultado. Por favor, tente novamente (${bodyResultStatus.msg}).`);
        setHasError(true);
        return;
      }
      const codStatusMap = {
        0: 'nothingDone',
        1: 'accepted',
        2: 'refused',
        3: 'waitingAnswer',
        4: 'answered',
      };
      const codStatusActionsMap = {
        0: () => toast.info('Resultado gerado! Por favor, selecione uma das opções para prosseguir.', {
          toastId: 'resultDone',
        }),
        1: () => toast.info('Seu resultado já foi aceito e implantado!', {
          toastId: 'resultImplanted',
          autoClose: false,
        }),
        2: () => toast.info('Você já optou pela não utilização do VT.', {
          toastId: 'resultImplanted',
          autoClose: false,
        }),
        3: () => toast('Por favor, aguarde enquanto nossa equipe ajusta seu resultado conforme solicitado', {
          icon: '🕓',
          toastId: 'resultWaiting',
          autoClose: false,
        }),
        4: () => toast.success('Sua solicitação de ajuste foi respondida. Este é seu novo resultado!', {
          toastId: 'adjustmentAnswered',
        }),
      };
      codStatusActionsMap[bodyResultStatus.codStatus]();
      setResultStatus(codStatusMap[bodyResultStatus.codStatus]);
      setAllowPdfDownload(bodyResultStatus.ExibeCarta);
    } catch (error) {
      toast.error(`Não foi possível carregar seu resultado. Por favor, tente novamente (${error})`);
      setHasError(true);
    }
  }, [consultCode, token]);

  const loadResult = useCallback(async () => {
    try {
      setIsLoading(true);
      setHasError(false);
      await Promise.all([
        getResult(),
        checkResultStatus(),
        checkIfCanShowMap(),
      ]);
    } catch (error) {
      toast.error(`Não foi possível carregar a página. Por favor, tente novamente (${error}).`);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [checkResultStatus, getResult, checkIfCanShowMap]);

  const requestAdjustment = useCallback(async () => {
    try {
      setAdjustmentModalShow(false);
      setIsSomeActionLoading(true);
      const adjustmentRequest = await resultService.makeAdjustmentRequest({
        token,
        comentario: encodeURIComponent(adjustmentReason),
        codConsulta: consultCode,
      });
      if (!adjustmentRequest.codigo) {
        toast.error(`Não foi possível enviar sua solicitação. Por favor, tente novamente (${adjustmentRequest.msg}).`);
        setAdjustmentModalShow(true);
        return;
      }
      setResultStatus('waitingAnswer');
      toast.success('Sua solicitação foi enviada com sucesso. Por favor, aguarde até que nossa equipe ajuste seu resultado. Você receberá um aviso no seu e-mail quando o processo for concluído.');
    } catch (error) {
      toast.error(`Não foi possível enviar sua solicitação. Por favor, tente novamente (${error}).`);
      setAdjustmentModalShow(false);
    } finally {
      setIsSomeActionLoading(false);
    }
  }, [adjustmentReason, consultCode, token]);

  const handleResultAction = useCallback(async (action, canvas) => {
    try {
      setIsSomeActionLoading(true);
      const bodyAction = await resultService.handleResultAction({
        token,
        codConsulta: consultCode,
        cancelamento: action === 'refuse',
        exibeCarta: allowPdfDownload,
      });
      if (!bodyAction.codigo) {
        toast.error(`Não foi possível ${action === 'refuse' ? 'recusar o benefício' : 'implantar o resultado'}. Por favor, tente novamente (${bodyAction.msg}).`);
        if (action === 'refuse') {
          setRefuseModalShow(true);
        } else {
          setAcceptModalShow(true);
        }
        return;
      }
      setResultStatus(action === 'refuse' ? 'refused' : 'accepted');

      if (allowPdfDownload) {
        // const docLink = bodyAction.linkCarta;
        // const logoSrc = bodyAction.linkLogo;

        // const sentWhatsapp = await sendLinkWhatsapp({
        //   phone: employeeCellphone,
        //   message: `😄 Seu processo de roteirização de vale-transporte foi concluído com sucesso! Você pode visualizar e baixar a sua carta de opção de Vale-Transporte através do link abaixo:\n\nCaso não consiga clicar no link, responda a essa mensagem, ou nos adicione em sua lista de contatos.\n\n${docLink}`,
        //   image: logoSrc,
        //   linkUrl: docLink,
        //   title: 'Carta de Vale-Transporte',
        //   linkDescription: 'Clique aqui para acessar sua carta de opção de Vale-Transporte!',
        // });

        // const sentWhatsapp = await sendDocumentWhatsapp({
        //   phone: employeeCellphone,
        //   message: `👋 Olá, ${employeeName}! \n\n😄 Boa notícia! \n\nSeu processo de roteirização de vale-transporte foi concluído com sucesso! Aqui está a sua carta de opção de Vale-Transporte.`,
        //   linkUrl: docLink,
        //   fileName: `Carta de Opção de VT - ${employeeName}`,
        //   companyName,
        //   contactName: employeeName,
        // });

        const channelsThatMessageWasSent = [bodyAction.enviouEmail ? 'e-mail' : ''].filter((x) => !!x);

        toast.info(`Não se esqueça de fazer o download de sua carta clicando no botão "Baixar Carta", e enviá-la para o RH de sua empresa! ${channelsThatMessageWasSent.length ? `Também enviamos o link para acessar a carta em seu ${renderArrayWithComa(channelsThatMessageWasSent)}` : ''}`, { style: { fontWeight: 'bold' } });
      }

      const dataUrl = canvas.toDataURL('image/png');
      const byteString = atob(dataUrl.split(',')[1]);
      const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      const file = new File([blob], 'image.png', { type: 'image/png' });

      const bodySendSignature = await resultService.sendSignature({
        codFuncionario: employeeCode,
        reqBody: [{ key: 'file', value: file }],
      });
      if (!bodySendSignature.codigo) {
        toast.error(`Não foi possível registrar a assinatura, mas não se preocupe! O seu resultado foi implantado normalmente. (${bodySendSignature.msg}).`);
      }
      toast.success(action === 'refuse' ? 'A opção pela não utilização do VT foi registrada com sucesso!' : 'Resultado aceito e implantado com sucesso!');
      setAcceptModalShow(false);
      setRefuseModalShow(false);
    } catch (error) {
      toast.error(`Não foi possível ${action === 'refuse' ? 'recusar o benefício' : 'implantar o resultado'}. Por favor, tente novamente (${error}).`);
      if (action === 'refuse') {
        setRefuseModalShow(true);
      } else {
        setAcceptModalShow(true);
      }
    } finally {
      setIsSomeActionLoading(false);
    }
  }, [allowPdfDownload, consultCode, employeeCode, token]);

  const handleObjectionStream = useCallback(async (userMessage, currentHistory) => {
    const initResponse = await fetch(`${aiBaseUrl}/gemini/handle-objection/stream/init`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        routingId: Number(consultCode),
        companyId,
        history: [...currentHistory, { role: 'user', text: userMessage }],
        shouldPresentOptionsForManualRouting: true,
      }),
    });

    if (!initResponse.ok) {
      throw new Error('SSE init request failed');
    }

    const { streamId } = await initResponse.json();

    return new Promise((resolve, reject) => {
      const es = new EventSource(`${aiBaseUrl}/gemini/handle-objection/stream/${streamId}`);

      es.onmessage = (ev) => {
        const parsed = JSON.parse(ev.data);
        if (parsed.event === 'chunk') {
          setAiStreamingText((prev) => { const next = prev + parsed.text; aiStreamingTextRef.current = next; return next; });
        } else if (parsed.event === 'result') {
          es.close();
          resolve(parsed);
        } else if (parsed.event === 'error') {
          es.close();
          aiStreamingTextRef.current = '';
          setAiStreamingText('');
          reject(new Error(parsed.message || 'SSE error'));
        }
      };

      es.onerror = (err) => {
        es.close();
        aiStreamingTextRef.current = '';
        setAiStreamingText('');
        reject(err);
      };
    });
  }, [consultCode, companyId]);

  const sendMessageToAI = useCallback(async (userMessage, currentHistory, retryCount = 0) => {
    try {
      let data;
      if (useGeminiStream) {
        data = await handleObjectionStream(userMessage, currentHistory);
      } else {
        const response = await fetch(`${aiBaseUrl}/gemini/handle-objection`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            routingId: Number(consultCode),
            companyId,
            history: [...currentHistory, { role: 'user', text: userMessage }],
            shouldPresentOptionsForManualRouting: true,
          }),
        });

        if (!response.ok) {
          throw new Error('API request failed');
        }

        data = await response.json();
      }

      return { success: true, data };
    } catch (error) {
      if (retryCount < 2) {
        await new Promise((resolve) => { setTimeout(resolve, 5000); });
        return sendMessageToAI(userMessage, currentHistory, retryCount + 1);
      }
      toast.error('Não foi possível se comunicar com o assistente. Por favor, tente novamente.');
      return { success: false, error };
    }
  }, [consultCode, companyId, handleObjectionStream]);

  const applyAiResult = useCallback(async (data) => {
    const updatedHistory = data.history || [];
    setAiChatHistory(updatedHistory);

    if (data.forceResultShow) {
      setForceResultShow(true);
      setExceededPrice(false);
      setCanUseAiAssistant(false);
      setAiModalShow(false);
      return;
    }

    if (data.recalculationTriggered) {
      const recalculationMessage = {
        role: 'model',
        text: 'Entendi os pontos que você mencionou! Vou recalcular seu resultado de acordo com o que conversamos. Aguarde um momento enquanto processo as alterações... 🔄',
      };
      setAiChatHistory([...updatedHistory, recalculationMessage]);
      await new Promise((resolve) => { setTimeout(resolve, 6000); });
      navigate(`/?codEmpresa=${companyId}&codConsulta=${consultCode}&codFuncionario=${employeeCode}`);
    }

    if (data.forceManualRouting) {
      const manualRoutingMessage = {
        role: 'model',
        text: 'Vou redirecionar você para inserir manualmente os bilhetes desta roteirização. Só um momento...',
      };
      setAiChatHistory([...updatedHistory, manualRoutingMessage]);
      await new Promise((resolve) => { setTimeout(resolve, 6000); });
      navigate(`/?codEmpresa=${companyId}&codConsulta=${consultCode}&codFuncionario=${employeeCode}&mustForceManualRouting`);
    }
  }, [consultCode, companyId, employeeCode, navigate]);

  const handleStreamingDone = useCallback(() => {
    aiStreamingTextRef.current = '';
    setAiStreamingText('');
    setIsAiLoading(false);
    if (pendingAiResultRef.current) {
      applyAiResult(pendingAiResultRef.current);
      pendingAiResultRef.current = null;
    }
    if (streamingDoneResolverRef.current) {
      streamingDoneResolverRef.current();
      streamingDoneResolverRef.current = null;
    }
  }, [applyAiResult]);

  const handleAiMessage = useCallback(async (userMessage) => {
    const newUserMessage = { role: 'user', text: userMessage };
    const updatedHistory = [...aiChatHistory, newUserMessage];
    setAiChatHistory(updatedHistory);

    aiStreamingTextRef.current = '';
    setAiStreamingText('');
    setIsAiLoading(true);
    const result = await sendMessageToAI(userMessage, aiChatHistory);

    if (!result.success) {
      setAiStreamingText('');
      setIsAiLoading(false);
      setAiChatHistory(aiChatHistory);
      setAiModalShow(false);
      return;
    }

    if (useGeminiStream) {
      pendingAiResultRef.current = result.data;
      if (!aiStreamingTextRef.current) {
        const seedText = result.data.messageToUser || '';
        if (!seedText) {
          await applyAiResult(result.data);
          setIsAiLoading(false);
          pendingAiResultRef.current = null;
          return;
        }
        aiStreamingTextRef.current = seedText;
        setAiStreamingText(seedText);
      }
      await new Promise((resolve) => { streamingDoneResolverRef.current = resolve; });
    } else {
      await applyAiResult(result.data);
      setIsAiLoading(false);
    }
  }, [aiChatHistory, sendMessageToAI, applyAiResult]);

  const handleOpenAdjustmentModal = useCallback(() => {
    if (canUseAiAssistant) {
      setAiModalShow(true);
    } else {
      setAdjustmentModalShow(true);
    }
  }, [canUseAiAssistant]);

  function handleTryAgain() {
    loadResult();
  }

  function handleAdjustmentReasonChange(event) {
    setAdjustmentReason(event.target.value);
    setRemainingAdjustmentChars(300 - event.target.value.length);
  }

  useEffect(() => {
    loadResult();
  }, [loadResult]);

  return {
    isLoading,
    goingRoute,
    returningRoute,
    tickets,
    view,
    setView,
    logo,
    hasError,
    exceededPrice,
    totalPrice,
    resultStatus,
    allowPdfDownload,
    handleTryAgain,
    consultCode,
    adjustmentReason,
    handleAdjustmentReasonChange,
    setAdjustmentModalShow,
    requestAdjustment,
    adjustmentModalShow,
    isSomeActionLoading,
    setRefuseModalShow,
    acceptModalShow,
    setAcceptModalShow,
    refuseModalShow,
    handleResultAction,
    remainingAdjustmentChars,
    isRefuseButtonDisabled,
    setIsRefuseButtonDisabled,
    isAcceptButtonDisabled,
    setIsAcceptButtonDisabled,
    isBkConsultAndNotOptimized,
    canShowMap,
    isTicketsTabVisible,
    companyToRedirectMinorApprentice,
    isMinorApprentice,
    lastReclamationAndAnswer,
    aiChatHistory,
    aiModalShow,
    setAiModalShow,
    isAiLoading,
    aiStreamingText,
    canUseAiAssistant,
    aiRejectionReason,
    handleAiMessage,
    handleStreamingDone,
    handleOpenAdjustmentModal,
    setRejectionReasonModalShow,
    rejectionReasonModalShow,
    forceResultShow,
  };
}
